<template>
  <div class="container menus">
    <van-cell-group class="menus__list">
      <!-- to='setting-self' -->
      <van-cell title="个人信息" size="large" is-link @click="linkComponents" />
      <!--  to='setting-safe'  -->
      <van-cell title="安全设置" size="large" is-link @click="linkComponents" />
      <van-cell title="支付设置" size="large" is-link @click="linkComponents" />
      <div class="btn_box">
        <van-button style="margin-top:50px" round type="info" size="large" @click="signOut">退出登录</van-button>
      </div>
    </van-cell-group>
  </div>
</template>

<script>
import store from "../../store";
import { CellGroup } from 'vant'
export default {
  name: 'SettingCenter',
  components: {
    [CellGroup.name]: CellGroup
  },
  data () {
    return {}
  },


  destroyed () {  // 销毁时取消监听
  },
  methods: {
    // 登出 
    signOut () {
      // Dialog.confirm({
      //   title: "确定登出",
      //   message: "请确认是否登出",
      //   confirmButtonText: "确定登出",
      //   cancelButtonText: "取消"
      // })
      //   .then(() => {

      store.dispatch("FedLogOut")
      // })
      // .catch(() => {
      //   // on cancel
      // });
    },
    // 跳转
    linkComponents () {
      this.$toast('暂未开通 敬请期待！')
    }
  }
}
</script>

<style lang="scss" scoped>
.menus {
  height: 100vh;
  background: #f4f6f7;

  &__list {
    &__icon {
      font-size: 20px;
      line-height: 24px;
      margin-right: 5px;
      height: 24px;
    }
  }
}
.btn_box {
  padding: 0 15px;
}
</style>